/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div class="row">
    <div
      v-if="mode === 'loading'"
      class="btc-signin col-sm5 text-center"
    >
      <h1>
        <svg
          class="icon-refresh rotate large-spinner"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
        </svg>
        Loading...
      </h1>
    </div>
    <div
      v-if="mode === 'error'"
      class="btc-signin col-sm5"
    >
      <h1>Error While Logging In</h1>
      The following error was encountered while trying to log you in to VoiceVibes:<br>
      <div class="login-error">
        {{ error }}
      </div>
      Please retry your request, or contact
      VoiceVibes support via
      <a href="mailto:support@bigtincan.com">
        support@bigtincan.com
      </a>
      if the error persists.
      <br><br>
      You can also
      <router-link
        :to="{ name: 'sign-in'}"
      >
        return to the VoiceVibes Sign-In page.
      </router-link>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .btc-signin {
    padding: 0 20px;
  }
  .login-error {
    padding: 20px;
  }
</style>

<script>
import BtcMixin from '../specials/BtcMixin';
import auth from '../../services/auth';
import BasePage from './BasePage';

export default {
  mixins: [BtcMixin, BasePage],
  data() {
    return {
      mode: 'loading',
      error: 'Unknown Error',
    };
  },
  created() {
    this.$store.dispatch('signInFromLocalStorage').then((alreadySignedIn) => {
      if (alreadySignedIn === false) {
        return this.executeSignIn();
      }
      return this.$router.push({path: this.homepage});
    });
  },
  methods: {
    executeSignIn() {
      if (!this.$router.currentRoute.query.code) {
        this.sendToBtcHub();
      }

      const code = this.$router.currentRoute.query.code;
      const _state = this.$router.currentRoute.query.state;

      auth.btcSignIn({code})
        .then((data) => {
          if (!data || !data.apiKey || !data.orgCode) {
            throw new Error('Could not retrieve valid sign-in key');
          }

          // Redirect them to the Sign-In page with their token
          let query = {key: data.orgCode + '-' + data.apiKey};
          if (_state && _state.match(/[a-zA-Z]/gi)) {
            // Only pass alphabetic states (ie, bounce pages) thru to sign-in
            query.next = _state;
          }
          this.$router.push({name: 'sign-in', query});
        })
        .catch((data) => {
          this.error = (data && data[0] && data[0].message) ? data[0].message : 'Unknown Error';
          this.mode = 'error';
        });
    }
  }
};
</script>
